import script from "./uploadFileModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./uploadFileModal.vue?vue&type=script&lang=ts&setup=true"

import "./uploadFileModal.vue?vue&type=style&index=0&id=1ad23213&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ad23213"]])

export default __exports__